import gql from 'graphql-tag';
import { CatalogItemCardFragment } from '../fragments/fragments.cartEndpoint';

const MainPageQuery = {
  getRecipesMainPage: gql`
    query getRecipesMainPage {
      getRecipesMainPage {
        id
        title
        text
        recipes_difficult
        slozhnostItem {
          id
          title
        }
        cooking_time
        rating
        serving
        attachmentsItem {
          cacheItem {
            filePath
          }
        }
      }
    }
  `,
  getMainPageBanners: gql`
    query getMainPageBanners {
      getMainPageBanners {
        id
        title
        link
        file_new
        bannerFilePath
      }
    }
  `,
  getCatalogItemsByPromotionId: gql`
  query getCatalogItemsByPromotionId {
    getCatalogItemsByPromotionId(type:"pofd") {
      ...CatalogItemCardFragment
    }
    ${CatalogItemCardFragment}
  }`,
  getRecommendItems: gql`
    query getRecommendItems {
      getRecommendItems {
        ...CatalogItemCardFragment
      }
    }
    ${CatalogItemCardFragment}
  `,
  getPopularMainPageItems: gql`
    query getPopularMainPageItems {
      getPopularMainPageItems {
        ...CatalogItemCardFragment
      }
    }
    ${CatalogItemCardFragment}
  `,
  getNewbeeItems: gql`
    query getNewbeeItems {
      getNewbeeItems {
        ...CatalogItemCardFragment
      }
    }
    ${CatalogItemCardFragment}
  `,
  addSubscriberTemp: gql`
    mutation addSubscriberTemp($subscribeEmail: String!) {
      addSubscriberTemp(subscribeEmail: $subscribeEmail) {
        result
        error
        info
        email_sent
      }
    }
  `,
  callback: gql`
    query callback($phone: String!, $fio: String!) {
      callback(phone: $phone, fio: $fio) {
        result
      }
    }
  `,
  sendEmailForTableBooking: gql`
    query sendEmailForTableBooking(
      $name: String!
      $phone: String!
      $storeId: Int!
      $dateTime: DateTime!
      $guestsQuantity: Int!
    ) {
      sendEmailForTableBooking(
        name: $name
        phone: $phone
        storeId: $storeId
        dateTime: $dateTime
        guestsQuantity: $guestsQuantity
      ) {
        success
        error
      }
    }
  `,
  sendEmailForCatering: gql`
    query sendEmailForCatering(
      $name: String!
      $phone: String!
      $dateTime: DateTime!
    ) {
      sendEmailForCatering(dateTime: $dateTime, phone: $phone, name: $name) {
        success
        error
      }
    }
  `,
  getIndexCoreBanners: gql`
    query getIndexCoreBanners(
      $blocksFilter: [String!]
      $bannersLimit: Int
      $imageSizeFilter: String
      $bannersImageSize: String = "w900"
      $cartToken: String
      $storeId: Int
    ) {
      getIndexCore(
        blocksFilter: $blocksFilter
        bannersLimit: $bannersLimit
        imageSizeFilter: $imageSizeFilter
        cartToken: $cartToken
        storeId: $storeId
        bannersImageSize: $bannersImageSize
      ) {
        banners {
          id
          title
          product_title
          link
          file_new
          bannerFilePath
          fileItem {
            cacheItem {
              filePath
            }
          }
          catalogItems {
            id
            title
            oldPrice
            price
            discounPriceField
            discounPriceField2
            currentPriceField
            currentPriceField2
            oldPriceField
            oldPriceField2
            priceBlockWeightPrice
            specialPriceData {
              price1Kg
              price
              amount
            }

            multiPrices {
              id
              store_id
              price_active
              price_current
              price_retail
              staff
            }

            measureItem {
              weight
              symbol
            }
          }
        }
      }
    }
  `,
  getBannerById: gql`
    query getBannerById($bannerId: Int) {
      getBannerById(bannerId: $bannerId) {
        id
        title
        product_title
        link
        file_new
        bannerFilePath
        catalogItems {
          id
          title
          oldPrice
          price
          discounPriceField
          discounPriceField2
          currentPriceField
          currentPriceField2
          oldPriceField
          oldPriceField2
          priceBlockWeightPrice
          specialPriceData {
            price1Kg
            price
            amount
          }

          measureItem {
            weight
            symbol
          }
        }
      }
    }
  `,
  getIndexCoreRecipes: gql`
    query getIndexCoreRecipes(
      $blocksFilter: [String!]
      $recipesLimit: Int
      $cartToken: String
    ) {
      getIndexCore(
        blocksFilter: $blocksFilter
        recipesLimit: $recipesLimit
        cartToken: $cartToken
      ) {
        recipes {
          id
          isFavorite
          title
          rating
          text
          date
          author
          comments_number
          identifyIdURI
          recipes_difficult #  иконка с шапкой повара. от 1-го до 5
          slozhnostItem {
            id
            title
          }
          cooking_time # время приготовления
          rating # если 0, то "не оценен" https://www.delikateska.ru/recipes/1775
          serving # порции
          bludoItem {
            id
            title
          }
          attachmentsItem {
            cacheItem {
              filePath # путь карлито
            }
          }
        }
      }
    }
  `,
  getIndexCore: gql`
    query getIndexCore(
      $pofdProducts: Boolean! = false
      $popularProducts: Boolean! = false
      $newbeeProducts: Boolean! = false
      $blocksFilter: [String!]
      $productsLimit: Int
      $pofdLimit: Int
      $imageSizeFilter: String
      $cartToken: String
    ) {
      getIndexCore(
        blocksFilter: $blocksFilter
        productsLimit: $productsLimit
        pofdLimit: $pofdLimit
        imageSizeFilter: $imageSizeFilter
        cartToken: $cartToken
      ) {
        # pofdProductssTime
        # pofdProductsDateEnd
        pofdProducts @include(if: $pofdProducts) {
          ...CatalogItemCardFragment
        }
        popularProducts @include(if: $popularProducts) {
          ...CatalogItemCardFragment
        }
        newbeeProducts @include(if: $newbeeProducts) {
          ...CatalogItemCardFragment
        }
      }
    }
    ${CatalogItemCardFragment}
  `,
  getIndexAddition: gql`
    query getIndexAddition(
      $recommendProducts: Boolean! = false
      $interestProducts: Boolean! = false
      $productsLimit: Int
      $cartToken: String
    ) {
      getIndexAddition(productsLimit: $productsLimit, cartToken: $cartToken) {
        peopleProfile {
          id
          title
        }
        recommendProducts @include(if: $recommendProducts) {
          ...CatalogItemCardFragment
        }
        interestProducts @include(if: $interestProducts) {
          ...CatalogItemCardFragment
        }
      }
    }
    ${CatalogItemCardFragment}
  `,
  getIndexReviews: gql`
    query getIndexReviews($reviewsLimit: Int) {
      getIndexReviews(reviewsLimit: $reviewsLimit) {
        reviews {
          id
          text
          date
          rating
          votes_yes
          votes_no
          fio
          answer
          answer_user_id
          answer_date
          peopleItem {
            attachmentsItem {
              cacheItem {
                filePath
              }
            }
          }
          answerUserItem {
            fio
            attachmentsItem {
              cacheItem {
                id
                filePath
              }
            }
          }
          tagList {
            id
            title
            sort
            active
          }
          _voted
          photos {
            id
            thumb
            big
            isVideo
            video {
              title
              file
              width
              height
              converted
            }
          }
        }
      }
    }
  `
};

export default MainPageQuery;
